
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { BlurhashCanvas } from "react-blurhash";
import Icon from 'common/components/elements/icons';

const NoneAccess = ({
   state,
   type,
   unlockPrice,
   onClickButton,
   blurhash,
   rounded,
   showComingSoon,
   paymentButtonLoading,
   streamState,
   isLockedForAllMemberships,
}) => {

   const [unlockLoading, setUnlockLoading] = useState(false);
   useEffect(() => {
      if(unlockLoading && !paymentButtonLoading) {
         setUnlockLoading(false)
      }
   }, [paymentButtonLoading, unlockLoading])

   return (
      <>
         <BlurhashCanvas
            hash={ blurhash }
            punch={ 1 }
            className={ `absolute w-full h-full z-0 flex flex-col justify-between inset-0 rounded-${ rounded }` }
         />
         {
            !showComingSoon && (
               <div className='w-full h-full flex justify-center items-center z-10'
                  style={ {
                     backgroundColor: 'rgba(29, 41, 57, 0.3)',
                     backdropFilter: 'blur(4px)',
                  } }
               >
                  <Icon
                     size='[80px]'
                     name='lock'
                     className=' text-[80px] !text-[#FFFFFF99] dark:!text-[#FFFFFF99] '
                     darkColor='#FFFFFF99'
                     style={ {
                        opacity: '.9',
                     } }
                  />
               </div>
            )
         }
      </>
   )
}

NoneAccess.propTypes = {
   unlockPrice: PropTypes.number,
   onClickButton: PropTypes.func,
   blurhash: PropTypes.string,
   rounded: PropTypes.string,
   showComingSoon: PropTypes.bool,
   paymentButtonLoading: PropTypes.bool,
   type: PropTypes.oneOf([
      'video',
      'photoset',
   ]),
   state: PropTypes.oneOf([
      'only_member_can_unlock',
      'available_member',
      'unlock',
      'unlock_or_join',
      'pre_release',
      '',
   ]),
   streamState: PropTypes.string,
   isLockedForAllMemberships: PropTypes.bool,
}
NoneAccess.defaultProps = {
   rounded: 'none',
}

export default NoneAccess
